// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"ConfirmButton_confirmButton__1O5sQ"};